import { render, staticRenderFns } from "./PressCarousel.vue?vue&type=template&id=04cfe674&"
import script from "./PressCarousel.vue?vue&type=script&lang=js&"
export * from "./PressCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports